import { Grid } from '@mui/material'
import { styled } from '@mui/material/styles'

export const Form = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  flex: 1,
  marginTop: theme.spacing(1),

  '& input[type=number]': {
    '-moz-appearance': 'textfield',
  },
}))

export const Otp = styled(Grid)({ paddingTop: '0!important' })
